import Link from "next/link";

import {
  COMPANY_LEGAL_NAME,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
} from "@/app/(public)/_components/site-constants";
import { ROUTES } from "@/app/_libs/constants/routes";

const FOOTER_LINKS = [
  { href: ROUTES.CONTACT_US, label: "Contact Us" },
  { href: ROUTES.TERMS_AND_CONDITIONS, label: "Terms & Conditions" },
  { href: ROUTES.PRIVACY_POLICY, label: "Privacy Policy" },
] as const;

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 mt-10 border-t border-white/10 px-5 py-8 sm:mt-auto sm:px-6 md:px-10 lg:px-14">
      <div className="mx-auto flex w-full max-w-360 flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-col gap-1.5">
          <p className="text-foreground text-sm font-medium">{COMPANY_LEGAL_NAME}</p>
          <a
            href={SUPPORT_MAILTO}
            className="hover:text-brand-lime text-sm text-[#a3a3a3] transition-colors">
            {SUPPORT_EMAIL}
          </a>
          <p className="mt-2 text-xs text-[#737373]">
            © {year} {COMPANY_LEGAL_NAME}. All rights reserved.
          </p>
        </div>

        <nav aria-label="Legal" className="flex flex-col gap-2.5 sm:items-end">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="hover:text-brand-lime text-sm text-[#a3a3a3] transition-colors">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
